import React from "react";
import { motion } from "framer-motion";
import { HiExternalLink } from "react-icons/hi";

const education = [
  {
    name: "Sri Matha Matriculation Higher Secondary School, Kumbakonam - 612001",
    subtitle: "SSLC",
    year: "2020 - 2021",
    logo: "/logos/school.png",
  },
  {
    name: "Sri Matha Matriculation Higher Secondary School, Kumbakonam - 612001",
    subtitle: "Higher Secondary",
    year: "2022 - 2023",
    logo: "/logos/school.png",
  },
  {
    name: "Sri Krishna College of Technology",
    subtitle: "B.E – Computer Science and Engineering",
    year: "2022 - 2026",
    logo: "https://skct.edu.in/skct-quiz/clg.png",
    link: "https://skct.edu.in/",
  },
];

function EduRow({ item }) {
  return (
    <div className="group flex items-center justify-between gap-6 px-5 py-5 rounded-2xl transition">
      {/* Left */}
      <div className="flex items-center gap-4 min-w-0">
        {/* Logo */}
        <div className="h-14 w-14 rounded-full border border-black/10 dark:border-white/15 
          bg-white/80 dark:bg-white/10 backdrop-blur 
          flex items-center justify-center overflow-hidden shadow-sm">
          <img
            src={item.logo}
            alt={item.name}
            className="h-10 w-10 object-contain"
          />
        </div>

        {/* Text */}
        <div className="min-w-0">
          <div className="flex items-center gap-2">
            <h3 className="font-semibold text-[17px] md:text-[18px] text-black dark:text-white truncate">
              {item.name}
            </h3>

            {item.link && (
              <a
                href={item.link}
                target="_blank"
                rel="noreferrer"
                className="text-black/40 dark:text-white/40 hover:text-black dark:hover:text-white transition"
                title="Open website"
              >
                <HiExternalLink size={18} />
              </a>
            )}
          </div>

          {/* ✅ Subtitle */}
          <p className="text-[13px] text-black/50 dark:text-white/45 mt-1">
            {item.subtitle}
          </p>
        </div>
      </div>

      {/* Year */}
      <p className="text-[14px] md:text-[15px] text-black/50 dark:text-white/45 whitespace-nowrap">
        {item.year}
      </p>
    </div>
  );
}

export default function Education() {
  return (
    <section id="education" className="max-w-4xl mx-auto px-6 pb-20">
      {/* Heading */}
      <motion.h2
        initial={{ opacity: 0, y: 8 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
        className="text-xl font-bold text-black dark:text-white mb-5"
      >
        Education
      </motion.h2>

      {/* Glass Card */}
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
        className="
          relative max-w-4xl overflow-hidden rounded-3xl
          border border-black/10 dark:border-white/10
          bg-white/60 dark:bg-white/5
          backdrop-blur-xl
          shadow-[0_10px_30px_rgba(0,0,0,0.10)]
          dark:shadow-[0_10px_30px_rgba(0,0,0,0.45)]
        "
      >
        {/* Subtle gradient lights */}
        <div className="pointer-events-none absolute -top-24 -left-24 h-72 w-72 rounded-full bg-purple-500/15 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-sky-500/15 blur-3xl" />

        <div className="relative">
          {education.map((item, idx) => (
            <div
              key={idx}
              className="border-b border-black/10 dark:border-white/10 last:border-none"
            >
              <EduRow item={item} />
            </div>
          ))}
        </div>
      </motion.div>
    </section>
  );
}
